import React from 'react';
import { Aperture, BookOpen, Codepen, FileText } from 'react-feather';

const Paras = 'Faux real sexy split up the back pockets cut out detail on the front strappy brown paisley print. Leather asymmetric zip fastening wide lapels snap button zipped cuffs softer texture open asymmetric neckline tab sleeves.';

export const MainCardPara1 =
  ' Embellishment detailing to front and shoulders brocades quilting and fluffy-feel stitched gold. Fluffy soft kind to sensitive skin warm and cosy contrast cuffs ankles and neckline motif all-over floral design. Strech lining hemline above knee burgundy satin finish concealed zip small buttons rayon.  Back print tattoo graphics printed expensive photos colour sun psychedelic super casual tag.';
export const MainCardPara2 =
  "It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English. Many desktop publishing packages and web page editors now use Lorem Ipsum as their default model text, and a search for 'lorem ipsum' will uncover many web sites still in their infancy. Various versions have evolved over the years, sometimes by accident, sometimes on purpose (injected humour and the like";

export const ArticalsData = [
  {
    id: 1,
    title: 'Articles',
    para: Paras,
    icon: <BookOpen />,
  },
  {
    id: 2,
    title: 'Knowledgebase',
    para: Paras,
    icon: <Aperture />,
  },
  {
    id: 3,
    title: 'Support',
    para: Paras,
    icon: <FileText />,
  },
];

export const DetailesSidebarData = [
  {
    id: 1,
    title1: 'UX Development',
    title2: 'Course By',
    title3: 'Lorem ipsum',
    date: '18',
    month: 'Dec',
  },
  {
    id: 2,
    title1: 'Business Analyst',
    title2: 'Course By',
    title3: 'Lorem ipsum',
    date: '28',
    month: 'Oct',
  },
  {
    id: 3,
    title1: 'Web Development',
    title2: 'Course By',
    title3: 'Lorem ipsum',
    date: '1',
    month: 'May',
  },
];

export const LatestArticlesData = [
  {
    icon: <Codepen className='m-r-30' />,
    name: 'Using Video',
    desc: 'Cras dapibus. Vivamus elementum semper nisi. Aenean vulputate eleifend tellus.',
  },
  {
    icon: <Codepen className='m-r-30' />,
    name: 'Vel illum qu',
    desc: 'Cras dapibus. Vivamus elementum semper nisi. Aenean vulputate eleifend tellus.',
  },
  {
    icon: <Codepen className='m-r-30' />,
    name: 'Cum sociis natoqu',
    desc: 'Cras dapibus. Vivamus elementum semper nisi. Aenean vulputate eleifend tellus.',
  },
  {
    icon: <Codepen className='m-r-30' />,
    name: 'Using Video',
    desc: 'Cras dapibus. Vivamus elementum semper nisi. Aenean vulputate eleifend tellus.',
  },
  {
    icon: <Codepen className='m-r-30' />,
    name: 'Using Video',
    desc: 'Cras dapibus. Vivamus elementum semper nisi. Aenean vulputate eleifend tellus.',
  },
  {
    icon: <Codepen className='m-r-30' />,
    name: 'Using Video',
    desc: 'Cras dapibus. Vivamus elementum semper nisi. Aenean vulputate eleifend tellus.',
  },
  {
    icon: <Codepen className='m-r-30' />,
    name: 'Using Video',
    desc: 'Cras dapibus. Vivamus elementum semper nisi. Aenean vulputate eleifend tellus.',
  },
  {
    icon: <Codepen className='m-r-30' />,
    name: 'Using Video',
    desc: 'Cras dapibus. Vivamus elementum semper nisi. Aenean vulputate eleifend tellus.',
  },
  {
    icon: <Codepen className='m-r-30' />,
    name: 'Using Video',
    desc: 'Cras dapibus. Vivamus elementum semper nisi. Aenean vulputate eleifend tellus.',
  },
  {
    icon: <Codepen className='m-r-30' />,
    name: 'Using Video',
    desc: 'Cras dapibus. Vivamus elementum semper nisi. Aenean vulputate eleifend tellus.',
  },
  {
    icon: <Codepen className='m-r-30' />,
    name: 'Using Video',
    desc: 'Cras dapibus. Vivamus elementum semper nisi. Aenean vulputate eleifend tellus.',
  },
];
